import { create } from "zustand"
import { persist } from "zustand/middleware"

export type PanelId =
	| "main-nav"
	| "inbox-nav"
	| "inbox-list"
	| "thread-details"
	| "agent-list"

interface PanelWidthState {
	widths: Partial<Record<PanelId, number>>
	setWidth: (id: PanelId, width: number) => void
	resetWidth: (id: PanelId) => void
}

export const usePanelWidthState = create<PanelWidthState>()(
	persist(
		(set) => ({
			widths: {},
			setWidth: (id, width) => {
				set((state) => ({
					widths: { ...state.widths, [id]: Math.round(width) },
				}))
			},
			resetWidth: (id) => {
				set((state) => {
					const widths = { ...state.widths }
					delete widths[id]
					return { widths }
				})
			},
		}),
		{ name: "panel-widths" },
	),
)
